import {
  RASIO_KEUANGAN,
  RASIO_KEUANGAN_KUARTAL,
  RASIO_KEUANGAN_SINGLE,
  RASIO_KEUANGAN_YEAR,
} from "../../../constants";
const initial = {
  data: [],
  single: {},
  year: new Date().getFullYear(),
  kuartal: 1,
};
const drr = (state = initial, action) => {
  switch (action.type) {
    case RASIO_KEUANGAN_YEAR:
      return {
        ...state,
        year: action.data,
      };
    case RASIO_KEUANGAN_KUARTAL:
      return {
        ...state,
        kuartal: action.data,
      };
    case RASIO_KEUANGAN_SINGLE:
      return {
        ...state,
        single: action.data,
      };
    case RASIO_KEUANGAN:
      return {
        ...state,
        data: action.data,
      };
    default:
      return { ...state };
  }
};
export default drr;
